import React from 'react';
import PropTypes from 'prop-types';
import Popover from '@material-ui/core/Popover';
import { withStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
	paper: {
		padding: theme.spacing(1),
		maxWidth: '500px',
	},
	popover: {
		pointerEvents: 'none',
	},
	popperClose: {
		pointerEvents: 'none',
	},
	center: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-end',
	},
	center2: {
		display: 'flex',
		alignItems: 'center',
	},
});

class MouseOverPopover extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			anchorEl: null,
			popperOpen: false,
		};
		this.handlePopoverClose = this.handlePopoverClose.bind(this);
		this.handlePopoverOpen = this.handlePopoverOpen.bind(this);
	}

	handlePopoverOpen(event) {
		this.setState({ anchorEl: event.target });
	}

	handlePopoverClose() {
		this.setState({ anchorEl: null });
	}

	render() {
		const { classes, value, children, noJustify } = this.props;
		const { anchorEl } = this.state;
		const open = !!anchorEl;

		return (
			<div>
				<div
					onMouseOver={this.handlePopoverOpen}
					onMouseOut={this.handlePopoverClose}
					className={noJustify ? classes.center2 : classes.center}
				>
					{children}
				</div>
				<Popover
					className={classes.popover}
					classes={{
						paper: classes.paper,
					}}
					open={open}
					anchorEl={anchorEl}
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'left',
					}}
					transformOrigin={{
						vertical: 'top',
						horizontal: 'left',
					}}
					onClose={this.handlePopoverClose}
					disableRestoreFocus
				>
					{value}
				</Popover>
			</div>
		);
	}
}

MouseOverPopover.propTypes = {
	classes: PropTypes.object.isRequired,
	value: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.element, // For a single React element
	]),
	noJustify: PropTypes.bool,
	children: PropTypes.node,
};

export default withStyles(styles)(MouseOverPopover);
